import { createReducer } from '@reduxjs/toolkit';
import { SET_USER_INFO } from '../actions/user';
import AdminUser from '../models/admin_user';

const userReducer = createReducer({} as AdminUser, (builder) =>
  builder.addCase(SET_USER_INFO, (_, action) => new AdminUser(action.payload))
);

export default userReducer;
